module.exports = __webpack_public_path__ + "static/media/tape_1.2b269805.png";